import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import axios from 'axios'
import {
  Alert,
  ButtonContainer,
  Button
} from 'camino-react'

import { csrfToken } from 'Utilities/Csrf'
import { cloudhelpGet, cloudhelpPatch } from 'Utilities/CloudHelp'

import EditableFormInputFields from './EditableFormInputFields'
import ViewableFormFields from './ViewableFormFields'

class TimesheetForm extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      fields: {
        start_time: moment(props.start_time).toDate(),
        end_time: moment(props.end_time).toDate(),
        description: props.description,
        comments: props.comments,
        chargeable: props.chargeable,
        work_type_id: props.work_type_id,
        work_role_id: props.work_role_id,
        service_group_id: props.service_group_id || props.defaultServiceGroupId,
        utilization_deductable_minutes: props.utilization_deductable_minutes,
        send_to_contact: true
      },
      errors: [],
      flash: {},
      submitButton: {
        text: 'Submit',
        disabled: false
      },
      warningExtraPaid: {},
      extraPaid: {
        work_role_id: false,
        work_type_id: false
      }
    }
  }

  componentWillMount () {
    const itemsToRequest = ['work_roles', 'work_types']
    _.map(itemsToRequest, item => this.requestItems(item))
  }

  requestItems = (type) => {
    const { regionId } = this.props

    cloudhelpGet(`/api/${type}.json`, { region_id: regionId })
      .then((response) => {
        const typeKey = _.camelCase(type)
        this.setState({
          [typeKey]: response.data
        })
      })
  }

  setField = (fieldName, value) => {
    this.setState((prevState) => {
      const { fields } = prevState
      const newFields = Object.assign({}, fields, { [fieldName]: value })
      return (
        { fields: newFields }
      )
    })
  }

  enableSubmitButton = () => {
    this.setState({
      submitButton: {
        text: 'Submit',
        disabled: false
      }
    })
  }

  closeForm = () => {
    const { shouldReload, onClose } = this.props

    if (shouldReload) {
      window.location.reload(true)
    } else {
      onClose()
    }
  }

  updateTicketStatus = () => {
    const { fields, success } = this.state
    const { ticketId, shouldReload, onClose } = this.props
    const ticketData = {}

    _.map(fields, (value, key) => {
      if (key.includes('ticket_')) {
        ticketData[key.replace('ticket_', '')] = value
      }
    })

    if (_.isEmpty(ticketData)) {
      this.closeForm()
      return
    }

    cloudhelpPatch(`/tickets/${ticketId}`, { ticket: ticketData })
      .then((response) => {
        this.setState({
          ticketErrors: [],
          flash: {
            error: []
          }
        })

        this.enableSubmitButton()

        this.closeForm()
      })
      .catch((error) => {
        const { data: errorData } = error.response
        const errors = errorData.errors[0]

        this.setState((prevState) => {
          const { flash } = prevState

          const newFlash = Object.assign({}, flash, { ticketError: errors })

          return { errors, flash: newFlash, ticketErrors: errors }
        })
      })
      .then(() => this.enableSubmitButton())
  }

  submitTimesheet = () => {
    const {
      fields, ticketErrors, timesheetErrors, completeTask, extraPaid: { work_role_id, work_type_id }
    } = this.state
    const { url, method, taskId, hasManagedServiceGroup, onClose, shouldReload } = this.props
    const chargeableResult = hasManagedServiceGroup ? (work_role_id || work_type_id) : fields.chargeable
    const fieldsToSubmit = Object.assign({}, fields, {
      start_time: fields.start_time,
      end_time: fields.end_time,
      chargeable: chargeableResult
    })

    _.map(fields, (value, key) => {
      if (key.includes('ticket_')) {
        delete fieldsToSubmit[key]
      }
    })

    const data = {
      authenticity_token: csrfToken(),
      timesheet: fieldsToSubmit
    }

    this.setState({
      submitButton: {
        text: 'Submitting...',
        disabled: true
      }
    })

    if (_.isEmpty(ticketErrors)) {
      axios({ method, url, data })
        .then((response) => {
          const { data: { success } } = response

          this.setState({
            errors: [],
            flash: {
              success,
              error: []
            }
          })

          if (taskId && fields.complete_task) {
            delete fields.complete_task
            cloudhelpPatch(`/api/dispatcher/events/${taskId}`, { task: { completed_at: new Date() } })
          }

          if (_.includes(url, '/api/tickets')) {
            this.updateTicketStatus()
          }

          if (_.includes(url, '/api/problems')) {
            onClose()
          }

          this.enableSubmitButton()
        })
        .catch((error) => {
          const { data: errorData } = error.response
          const { errors } = errorData

          this.setState((prevState) => {
            const { flash } = prevState

            const newFlash = Object.assign({}, flash, { error: errors })

            return { errors, flash: newFlash, timesheetErrors: errors }
          })
        })
        .then(() => this.enableSubmitButton())
    }
    if (_.isEmpty(timesheetErrors) && !_.isEmpty(ticketErrors) && _.includes(url, '/api/tickets')) {
      this.updateTicketStatus()
    }
  }

  checkIfWorkTypeIsInServiceGroup = (type, value) => {
    const { fields: { work_type_id, work_role_id, service_group_id } } = this.state
    const { serviceGroups } = this.props

    if (!_.isNil(value) && type === 'service_group_id') {
      const workTypesForSelectedServiceGroup = _.find(serviceGroups, { value }).work_types
      this.setWarningExtraCharge(workTypesForSelectedServiceGroup, work_type_id, 'work_type_id')
      if (!_.isNil(work_role_id)) {
        const workRolesForSelectedServiceGroup = _.find(serviceGroups, { value: work_role_id }).work_roles
        this.setWarningExtraCharge(workRolesForSelectedServiceGroup, work_role_id, 'work_role_id')
      }
    } else if (!_.isNil(service_group_id) && type === 'work_type_id') {
      const workTypesForSelectedServiceGroup = _.find(serviceGroups, { value: service_group_id }).work_types
      this.setWarningExtraCharge(workTypesForSelectedServiceGroup, value, type)
    } else if (!_.isNil(service_group_id) && type === 'work_role_id') {
      const workRolesForSelectedServiceGroup = _.find(serviceGroups, { value: service_group_id }).work_roles
      this.setWarningExtraCharge(workRolesForSelectedServiceGroup, value, type)
    }
  }

  setWarningExtraCharge = (workForSelectedServiceGroup, workId, type) => {
    if (!_.includes(_.map(workForSelectedServiceGroup, workType => workType.id), workId)) {
      this.setState((prevState) => {
        const { warningExtraPaid, extraPaid } = prevState
        const newWarningExtraPaid = Object.assign({}, warningExtraPaid, {
          [type]: `This ${type.replace('_id', '').replace('_', ' ')} is not in the selected Service Group and may cause the additional charge.`
        })
        const newExtraPaid = Object.assign({}, extraPaid, { [type]: true })

        return { warningExtraPaid: newWarningExtraPaid, extraPaid: newExtraPaid }
      })
    } else {
      this.setState((prevState) => {
        const { warningExtraPaid, extraPaid } = prevState
        const newWarningExtraPaid = _.omit(warningExtraPaid, type)
        const newExtraPaid = Object.assign({}, extraPaid, { [type]: false })
        return { warningExtraPaid: newWarningExtraPaid, extraPaid: newExtraPaid }
      })
    }
  }

  render () {
    const {
      flash,
      fields,
      submitButton,
      errors,
      workRoles,
      workTypes,
      warningExtraPaid,
      sendNotes
    } = this.state

    const { setField } = this
    const {
      allTimesheetsView,
      onClose,
      title,
      editableTimesheet,
      viewableTimesheet,
      start_time,
      end_time,
      duration_minutes,
      duration_minutes_with_deducted,
      description,
      comments,
      chargeable,
      work_type_name,
      work_role_name,
      utilization_deductable_minutes,
      newTimesheet,
      serviceGroups,
      hasManagedServiceGroup,
      paths,
      url,
      ticketStatuses,
      taskId,
      contactName,
      ccOptions,
      statusesRootIds,
      ticketCreatedAt,
      invoice_id,
      ticketTypeId
    } = this.props

    const { error, success, ticketError } = flash

    const workRolesOptionsByRegion = () => _.map(workRoles, ({ id, name }) => ({ value: id, label: name }))
    const workTypesOptionsByRegion = () => _.map(workTypes, ({ id, name }) => ({ value: id, label: name }))

    const selectBoxOptions = {
      service_group_id: serviceGroups,
      work_role_id: workRolesOptionsByRegion(),
      work_type_id: workTypesOptionsByRegion(),
      ticket_status_id: _.orderBy(ticketStatuses, 'label'),
      notes_cc: ccOptions
    }

    const errorList = _.map(error || [], (errorText, key) => `${_.startCase(key)} ${errorText}`)
    const ticketErrorList = _.map(ticketError || [], (ticketErrorText, key) => `${_.startCase(key)} ${ticketErrorText}`)
    const messageFlashes = _.map(success || [], message => (message))

    const valueProps = fieldName => ({
      value: fields[fieldName],
      errors: errors[fieldName.replace('ticket_', '')]
    })

    const selectBoxValueProps = fieldName => ({
      value: _.find(selectBoxOptions[fieldName], ({ value }) => value === fields[fieldName]),
      errors: errors[fieldName.replace('ticket_', '')]
    })

    const creatableBoxValueProps = fieldName => ({
      value: fields[fieldName],
      errors: errors[fieldName.replace('ticket_', '')]
    })

    const datetimeProps = fieldName => ({
      onValue: date => setField(fieldName, date),
      errors: errors[fieldName.replace('ticket_', '')]
    })

    const textareaProps = fieldName => ({
      rows: 3,
      onValue: event => setField(fieldName, event),
      errors: errors[fieldName.replace('ticket_', '')]
    })

    const checkboxProps = fieldName => ({
      onValue: value => setField(fieldName, value),
      value: fields[fieldName] === true
    })

    const selectBoxProps = fieldName => ({
      options: selectBoxOptions[fieldName],
      onValue: (value) => {
        setField(fieldName, value)

        if (fieldName === 'work_type_id' || fieldName === 'service_group_id' || fieldName === 'work_role_id') {
          this.checkIfWorkTypeIsInServiceGroup(fieldName, value)
        }
      },
      clearable: false
    })

    const creatableBoxProps = fieldName => ({
      options: selectBoxOptions[fieldName],
      onChange: (value) => { setField(fieldName, value) },
      clearable: true,
      multi: true
    })

    const ticketStatusInheritParentFields = (statusRootId) => {
      const ticketStatus = _.find(ticketStatuses, ['value', fields.ticket_status_id])

      return ticketStatus?.root_id === statusRootId && ticketStatus?.inherit_parent_fields
    }

    const minDateTimesheet = moment(ticketCreatedAt).toDate()

    return (
      <div className="card--padding-small" style={{ padding: allTimesheetsView ? '0 20px' : '' }}>
        <header className="modal__content-header">
          <h3 className="modal__content-header-title">
            {title}
          </h3>
          { paths && paths.timesheetHistoryIndexPath && (
            <a href={paths.timesheetHistoryIndexPath} className="modal__close">
              View history
            </a>
          ) }
        </header>
        {_.some(messageFlashes) && (
          <Alert type="success" title={messageFlashes} />
        )}
        {_.some(errorList) && (
          <Alert type="error" title="Timesheet can't be saved due to:">
            {errorList}
          </Alert>
        )}
        {_.some(ticketErrorList) && (
          <Alert type="error" title="Ticket status can't be updated due to:">
            {ticketErrorList}
          </Alert>
        )}
        {_.some(warningExtraPaid) && (
          <Alert type="error" title="Warning">
            {Object.values(warningExtraPaid)}
          </Alert>
        )}
        {(newTimesheet || editableTimesheet) && (
          <EditableFormInputFields
            valueProps={fieldName => valueProps(fieldName)}
            datetimeProps={fieldName => datetimeProps(fieldName)}
            textareaProps={fieldName => textareaProps(fieldName)}
            checkboxProps={fieldName => checkboxProps(fieldName)}
            selectBoxValueProps={fieldName => selectBoxValueProps(fieldName)}
            creatableBoxValueProps={fieldName => creatableBoxValueProps(fieldName)}
            selectBoxProps={fieldName => selectBoxProps(fieldName)}
            creatableBoxProps={fieldName => creatableBoxProps(fieldName)}
            fields={fields}
            errors={errors}
            serviceGroups={serviceGroups}
            hasManagedServiceGroup={hasManagedServiceGroup}
            ticketStatusInheritParentFields={statusRootId => ticketStatusInheritParentFields(statusRootId)}
            isForTicket={_.includes(url, '/api/tickets')}
            taskId={taskId}
            sendNotes={sendNotes}
            contactName={contactName}
            statusesRootIds={statusesRootIds}
            ticketTypeId={ticketTypeId}
          />
        )}

        {(viewableTimesheet || allTimesheetsView) && (
          <ViewableFormFields
            allTimesheetsView={allTimesheetsView}
            start_time={start_time}
            end_time={end_time}
            duration_minutes={duration_minutes}
            duration_minutes_with_deducted={duration_minutes_with_deducted}
            description={description}
            comments={comments}
            chargeable={chargeable}
            workType={work_type_name}
            workRole={work_role_name}
            utilizationDeductableMinutes={utilization_deductable_minutes}
            paths={paths}
            invoiceId={invoice_id}
          />
        )}

        {!allTimesheetsView && (
          <ButtonContainer center spaced>
            <Button outline onClick={onClose}>
              {editableTimesheet ? 'Cancel' : 'Close'}
            </Button>
            {(newTimesheet || editableTimesheet) && (
              <Button
                disabled={submitButton.disabled}
                onClick={this.submitTimesheet}
              >
                {submitButton.text}
              </Button>
            )}
          </ButtonContainer>
        )}
      </div>
    )
  }
}

TimesheetForm.defaultProps = {
  start_time: moment().toDate(),
  end_time: moment().toDate(),
  description: '',
  comments: '',
  chargeable: false,
  allTimesheetsView: false
}

export default TimesheetForm
